import React from 'react'

import { At, Block, LINE, Sheet, VLine } from './_shared/positioned'

// Réplica do modelo "Guia de Aplicação - Fosfina" da Biofix (A4), com as coordenadas em pt do modelo.
const LEFT = 25.7
const WIDTH = 543.5
const FONT = "'Times New Roman', Times, 'Liberation Serif', serif"
const MONO = "'Courier New', Courier, 'Liberation Mono', monospace"

// Linhas "EN" e "PT" de um campo com rótulos e valor centralizado numa caixa
const Pair = ({ y, label, value, labelX = 27.4, valueX, valueW, size = 9, align }) => (
  <>
    <At x={labelX} y={y}>
      {label}
    </At>
    <At x={valueX} y={y} w={valueW} size={size} bold align={align}>
      {value}
    </At>
  </>
)

const Gap = ({ height }) => <div style={{ height: `${height}pt` }} />

// Reduz a fonte quando o texto é longo, para o documento continuar em uma página
const fitSize = (text, [limit1, limit2], [normal, medium, small]) =>
  text.length <= limit1 ? normal : text.length <= limit2 ? medium : small

const Header = ({ data }) => (
  <>
    <Block top={18.6} height={58.4} borders="tb">
      <img
        src="/pdfs/biofix/logo.png"
        alt="Biofix Agri"
        style={{ position: 'absolute', left: '6.6pt', top: '2.8pt', width: '189pt', height: '52.6pt' }}
      />
      <At x={282.8} y={29.7} size={14.4} bold style={{ fontFamily: MONO }}>
        GUIA DE APLICAÇÃO - FOSFINA
      </At>
      <At x={282.8} y={58.8} size={14.4} bold style={{ fontFamily: MONO }}>
        APPLICATION GUIDE - PHOSPHINE
      </At>
    </Block>
    <Block top={77} height={26.2} borders="b">
      <At x={27.4} y={79.6}>
        O.S.
      </At>
      <At x={132.3} y={79.6}>
        {data.activityCode}
      </At>
      <At x={27.4} y={92.7}>
        Nº Comunicado
      </At>
      <At x={132.3} y={92.7}>
        {data.communicationNumber}
      </At>
      <VLine x={178.6} y1={77} y2={103.2} />
      <At x={180.3} y={79.6}>
        DATE:
      </At>
      <At x={232.6} y={79.6} w={146.4} bold align="center">
        {data.dateEn}
      </At>
      <At x={180.3} y={92.7}>
        Data:
      </At>
      <At x={232.6} y={93.3} w={146.4} size={8.2} bold align="center">
        {data.datePt}
      </At>
      <VLine x={379} y1={77} y2={103.2} />
      <At x={380.6} y={79.6}>
        Quantity:
      </At>
      <At x={380.6} y={92.7}>
        Quantidade:
      </At>
    </Block>
  </>
)

const IdentificationTable = ({ data }) => {
  const exportersSize = fitSize(data.exporters, [160, 300], [8.2, 7, 5.5])
  return (
    <>
      <Block top={116.2} height={39.3} borders="tb">
        <At x={27.4} y={118.8}>
          Company / Adress:
        </At>
        <At x={132.3} y={118.8} bold>
          BIOFIX AGRI LTDA.
        </At>
        <At x={27.4} y={131.9}>
          Empresa Credenciada:
        </At>
        <At x={132.3} y={131.9} bold>
          Rua Piauí, 1299, sala 4 - A - Centro - Avaré-SP
        </At>
        <At x={132.3} y={145} bold>
          CNPJ: 31.707.506/0001-69 - Cadastro Nº: BR SP 0896; CREA-SP: 2180493
        </At>
        <VLine x={130.6} y1={116.2} y2={155.5} />
      </Block>
      <Block minHeight={47.3} style={{ display: 'flex' }}>
        <div style={{ width: `${130.6 - LEFT}pt`, fontSize: '9pt', lineHeight: '9pt', padding: '2.6pt 1.7pt 0' }}>
          Interested / Adress:
        </div>
        <div style={{ flex: 1, borderLeft: LINE, padding: '3pt 1.4pt 0' }}>
          <div style={{ fontSize: '7.2pt', lineHeight: '8.2pt', fontWeight: 'bold', marginBottom: '9pt' }}>
            {data.interested}
          </div>
          <div
            style={{
              fontSize: '8.2pt',
              lineHeight: '10.3pt',
              fontWeight: 'bold',
              minHeight: '20.6pt',
              marginBottom: '6.5pt'
            }}
          >
            {data.interestedDetails}
          </div>
        </div>
      </Block>
      <Block style={{ display: 'flex', minHeight: '10.8pt', borderBottom: LINE }}>
        <div style={{ width: `${130.6 - LEFT}pt`, fontSize: '9pt', lineHeight: '9pt', padding: '0 1.7pt' }}>
          EXPORTADORES:
        </div>
        <div
          style={{
            flex: 1,
            borderLeft: LINE,
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: `${exportersSize}pt`,
            lineHeight: `${exportersSize * 1.15}pt`,
            marginTop: '-0.5pt',
            paddingBottom: '1pt'
          }}
        >
          {data.exporters}
        </div>
      </Block>
      <Block top={213.6} height={26.1} borders="b">
        <At x={27.4} y={216.2}>
          Vessel:
        </At>
        <At x={27.4} y={229.3}>
          Navio:
        </At>
        <VLine x={130.6} y1={213.6} y2={239.7} />
        <At x={130.6} y={222.4} w={149.6} bold align="center">
          {data.ship}
        </At>
        <VLine x={280.2} y1={213.6} y2={239.7} />
        <Pair y={216.2} labelX={281.8} label="Destination:" valueX={332.6} value={data.destinationEn} />
        <Pair y={229.3} labelX={281.8} label="Destino:" valueX={332.6} value={data.destinationPt} />
      </Block>
      <Block minHeight={26.7} borders="b" style={{ display: 'flex' }}>
        <div style={{ width: `${130.6 - LEFT}pt`, fontSize: '9pt', lineHeight: '13.1pt', padding: '2.6pt 1.7pt 0' }}>
          Place / Adress:
          <br />
          Local da Aplicação:
        </div>
        <div
          style={{
            flex: 1,
            borderLeft: LINE,
            padding: '1.7pt 1.4pt 0',
            fontSize: `${fitSize(data.place, [150, 300], [7.2, 6.4, 5.6])}pt`,
            lineHeight: '8.2pt',
            fontWeight: 'bold'
          }}
        >
          {data.place}
        </div>
      </Block>
    </>
  )
}

const TreatmentTable = ({ data }) => (
  <>
    <Block top={308.9} height={27.3} borders="t">
      <Pair y={311.5} label="Description of Goods:" valueX={132.3} value={data.goodsEn} />
      <Pair y={325.8} label="Tratamento de:" valueX={132.3} value={data.goodsPt} />
      <VLine x={280.2} y1={308.9} y2={336.2} />
      <At x={281.8} y={311.5}>
        Cubic Meters:
      </At>
      <At x={281.8} y={325.8}>
        Metros Cúbicos:
      </At>
      <At x={378.1} y={311.6} w={51.2} bold align="center">
        {data.cubicMeters}
      </At>
      <At x={378.1} y={325.3} w={51.2} bold align="center">
        {data.cubicMeters}
      </At>
      <VLine x={429.3} y1={308.9} y2={336.2} />
      <At x={430.9} y={311.5}>
        Exposure Time:
      </At>
      <At x={430.9} y={325.8}>
        Tempo de Exposição:
      </At>
      <At x={526} y={311.5} w={42.7} bold align="center">
        {data.exposureTime}
      </At>
      <At x={526} y={325.8} w={42.7} bold align="center">
        {data.exposureTime}
      </At>
    </Block>
    <Block top={336.2} height={28.6} borders="tb">
      <At x={27.4} y={340.1}>
        Dosage:
      </At>
      <At x={124.3} y={340.1} bold>
        {data.dosageEn}
      </At>
      <At x={27.4} y={354.3}>
        Dose:
      </At>
      <At x={124.3} y={353.9} bold>
        {data.dosagePt}
      </At>
      <VLine x={178.6} y1={336.2} y2={364.8} />
      <At x={180.3} y={340.1}>
        Temperature:
      </At>
      <At x={180.3} y={353.6}>
        Temperatura:
      </At>
      <VLine x={280.2} y1={336.2} y2={364.8} />
      <At x={281.8} y={340.1}>
        Quantity of fumigation products(g):
      </At>
      <At x={281.8} y={354.3}>
        Quantidade de produto utilizado (g):
      </At>
      <At x={430.5} y={340.1} w={138.2} bold align="center">
        {data.productQuantity}
      </At>
      <At x={430.5} y={354.3} w={138.2} bold align="center">
        {data.productQuantity}
      </At>
    </Block>
    <Block top={364.8} height={46.3} borders="b">
      <At x={27.4} y={372.3}>
        Type of Application:
      </At>
      <At x={27.4} y={395.5}>
        Forma de Aplicação:
      </At>
      <At x={132} y={372.8} size={7.2} bold>
        FUMIGATION IN HOLDS OF VESSEL
      </At>
      <At x={132} y={391.3} size={7.2} bold style={{ lineHeight: '9.3pt' }}>
        FUMIGAÇÃO EM PORÕES DE
        <br />
        EMBARCAÇÃO (FPE)
      </At>
      <VLine x={280.2} y1={364.8} y2={411.1} />
      <Pair
        y={372.3}
        labelX={281.8}
        label="Fumigant Product:"
        valueX={380}
        valueW={188.7}
        value="PHOSPHINE"
        align="center"
      />
      <Pair
        y={395.5}
        labelX={281.8}
        label="Produto Utilizado:"
        valueX={380}
        valueW={188.7}
        value="FOSFINA"
        align="center"
      />
    </Block>
    <Block top={411.1} height={28.6} borders="b">
      <At x={27.4} y={414.9}>
        Holds Numbers:
      </At>
      <At x={27.4} y={429.2}>
        Porões de Navio:
      </At>
      <At x={132.4} y={413.6} size={10} bold>
        {data.holds}
      </At>
      <At x={132.3} y={428}>
        {data.holds}
      </At>
      <VLine x={280.2} y1={411.1} y2={439.7} />
      <At x={281.8} y={414.9}>
        Commercial Product:
      </At>
      <At x={281.8} y={429.2}>
        Produto Comercial:
      </At>
      <At x={380} y={414} w={188.7} bold align="center">
        {data.productEn}
      </At>
      <At x={380} y={428.3} w={188.7} bold align="center">
        {data.productPt}
      </At>
    </Block>
    <Block top={439.7} height={72} borders="b">
      <At x={27.4} y={443.5}>
        Application Started at________________hrs.
      </At>
      <At x={27.4} y={457.8}>
        Aplicação Iniciada às__________________hs.
      </At>
      <At x={27.4} y={486.3}>
        Application Finished at_______________hrs.
      </At>
      <At x={27.4} y={501.2}>
        Aplicação Finalizada às________________hs.
      </At>
      <VLine x={232.2} y1={439.7} y2={511.7} />
      <At x={233.8} y={456.9}>
        Ventilation allowed on________,________, <u>2026</u> at __________hrs.
      </At>
      <At x={233.8} y={471.2}>
        Ventilação permitida no dia ______ de __________ de <u>2026</u> às __________hs.
      </At>
    </Block>
  </>
)

const PRECAUTIONS =
  'PRECAUÇÕES DE USO: Cuidado em não aspirar produto e não colocá-lo em contato com a pele, vedar os respiros dos porões. Manter a distância recomendada de segurança. Manter o produto longe de animais domésticos e crianças, bem como realizar a aplicação em ambientes distantes dos mesmos. Produto altamente tóxico. Cuidado com as aerações e retiradas de resíduos, seguir recomendações para neutralização do produto. Com relação ao meio ambientes, ter o máximo de cuidado com as embalagens vazias, as quais devem ser devolvidas ao fabricante ou revendedor conforme Artigo 53 do Decreto 4074 de 04/01/2002.'

const Precautions = () => (
  <>
    <Gap height={14.3} />
    <Block top={526} height={156.4} borders="tb">
      <At x={27.4} y={529.8} bold>
        PERSONAL, PROTECTION EQUIPMENT: GAS MASK, FILTER, APRON AND BOOTS, GLOVES
      </At>
      <At x={27.4} y={544.1} bold>
        E.P.I MÁSCARA FACIAL, FILTRO, AVENTAL E BOTAS, LUVAS - Seguir recomendação do fabricante
      </At>
      <At x={27.4} y={572.6} bold>
        COLLECTIVE PROTECTION EQUIPMENT: WARNING STRIPS AND PLATES
      </At>
      <At x={27.4} y={586.9} bold>
        E.P.C CONES, FITA ZEBRADA E PLACA DE ADVERTÊNCIA
      </At>
      <At x={27.4} y={612.6} w={541} italic wrap style={{ lineHeight: '11.4pt' }}>
        {PRECAUTIONS}
      </At>
    </Block>
  </>
)

const SignatureBoxes = ({ data }) => {
  const boxes = [
    { left: 25.7, width: 152.9, title: 'TECHNICAL APPLICATOR', subtitle: 'TÉCNICO APLICADOR' },
    { left: 232.2, width: 146.8, title: 'VESSEL CAPITAN', subtitle: 'USUÁRIO' },
    { left: 429.3, width: 139.4, title: 'ACCREDITED COMPANY', subtitle: 'RESP. TÉCNICO' }
  ]
  return (
    <Block top={682.4} height={145.3} style={{ borderLeft: 0, borderRight: 0 }}>
      <At x={27.4} y={685.6} style={{ textDecoration: 'underline' }}>
        Obs:
      </At>
      <At x={27.4} y={704.1} style={{ textDecoration: 'underline' }}>
        Local/data:
      </At>
      <At x={136.9} y={704.1} w={95} align="center" style={{ textDecoration: 'underline' }}>
        {data.mapaPort}
      </At>
      <At x={233.8} y={703.6} size={8.2} style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
        ................./........................................../.................
      </At>
      {boxes.map(({ left, width, title, subtitle }) => (
        <div
          key={title}
          style={{
            position: 'absolute',
            left: `${left - LEFT}pt`,
            top: `${727.7 - 682.4}pt`,
            width: `${width}pt`,
            height: '100pt',
            boxSizing: 'border-box',
            border: LINE,
            textAlign: 'center',
            fontSize: '9pt',
            lineHeight: '9pt'
          }}
        >
          <div style={{ position: 'absolute', top: '60pt', width: '100%', fontWeight: 'bold' }}>{title}</div>
          <div style={{ position: 'absolute', top: '75.2pt', width: '100%', fontStyle: 'italic' }}>{subtitle}</div>
        </div>
      ))}
    </Block>
  )
}

const Titles = () => (
  <Block top={266.4} height={42.5} style={{ borderLeft: 0, borderRight: 0, textAlign: 'center', fontWeight: 'bold' }}>
    <div style={{ position: 'absolute', top: '9.3pt', width: '100%', fontSize: '12.6pt', lineHeight: '12.6pt' }}>
      TREATMENT INFORMATION
    </div>
    <div style={{ position: 'absolute', top: '24.4pt', width: '100%', fontSize: '10pt', lineHeight: '10pt' }}>
      INFORMAÇÕES DO TRATAMENTO
    </div>
  </Block>
)

const GuideDocument = ({ data }) => (
  <div
    id="pdfPage"
    style={{ width: '595.2pt', boxSizing: 'border-box', padding: '6pt 26pt 0', background: '#fff', fontFamily: FONT }}
  >
    <style>{`@page { size: A4; margin: 0 }`}</style>
    <Sheet left={LEFT} style={{ width: `${WIDTH}pt`, color: '#000' }}>
      <Header data={data} />
      <Gap height={13} />
      <IdentificationTable data={data} />
      <Titles />
      <TreatmentTable data={data} />
      <Precautions />
      <SignatureBoxes data={data} />
    </Sheet>
  </div>
)

export default GuideDocument
